import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import classnames from '../utils/classnames.tsx';

const Tooltip = ({
    children,
    className,
    content,
    side,
    sideOffset,
    align,
    alignOffset,
    long,
    overflowOnly = false,
    asChild = true,
    open: openProp,
    onOpenChange: onOpenChangeProp,
}: any) => {
    const triggerRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const controlled = openProp !== undefined;
    const resolvedOpen = controlled ? openProp : isOpen;
    const handleOpenChange = controlled ? (onOpenChangeProp ?? (() => {})) : setIsOpen;

    useEffect(() => {
        if (!triggerRef?.current) return;
        triggerRef.current.addEventListener('mouseenter', () => {
            setIsOverflowing(triggerRef.current.scrollWidth > triggerRef.current.offsetWidth);
        });
    }, [triggerRef?.current]);

    return (
        <TooltipPrimitive.Provider>
            <TooltipPrimitive.Root
                open={(overflowOnly && !isOverflowing) || !content ? false : resolvedOpen}
                onOpenChange={handleOpenChange}
                delayDuration={100}
            >
                <TooltipPrimitive.Trigger ref={triggerRef} asChild={asChild}>
                    {children}
                </TooltipPrimitive.Trigger>
                <TooltipPrimitive.Portal>
                    <TooltipPrimitive.Content
                        side={side}
                        sideOffset={sideOffset}
                        align={align}
                        alignOffset={alignOffset}
                        collisionPadding={8}
                        className={classnames(
                            'select-none rounded bg-[rgba(0,0,0,0.9)] text-content-white backdrop-blur-md px-2.5 py-1.5 text-sm z-[60001] max-w-64',
                            long && 'max-w-96',
                            className
                        )}
                    >
                        {content}
                    </TooltipPrimitive.Content>
                </TooltipPrimitive.Portal>
            </TooltipPrimitive.Root>
        </TooltipPrimitive.Provider>
    );
};

export default Tooltip;
